export const issue = (state) => state.emision;

// TODO: remove alias
export const emision = issue;
